import { FC, HTMLAttributes, ReactNode } from "react";
import Image from "next/image";
import clsx from "clsx";

import HtmlText from "../common/HtmlText";

// ---------------------------------------------------------------------------------------

export type IReportingStandardSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  logos?: { src: string; alt: string }[];
};

const ReportingStandardSection: FC<IReportingStandardSectionProps> = (
  props,
) => {
  const { heading, description, logos, className, ...other } = props;

  return (
    <section className="py-5 lg:py-8 xl:py-[50px]">
      <div
        className={clsx(
          "flex justify-center bg-primary-50 py-5 lg:py-8 xl:py-[50px]",
          className,
        )}
        {...other}
      >
        <div className="container w-full">
          {heading && (
            // <div className="after:content before:content relative m-0 box-border flex w-full flex-row justify-start overflow-hidden p-0 before:absolute before:-left-1 before:z-50 before:flex before:h-full before:w-8 before:bg-gradient-to-r before:from-primary-50/100 before:via-primary-50/70 before:to-primary-50/20 before:opacity-100 after:absolute after:-right-1 after:z-50 after:h-full after:w-8 after:bg-gradient-to-r after:from-primary-50/20 after:via-primary-50/70 after:to-primary-50/100 after:opacity-100 md:before:w-10 md:after:w-10 lg:before:w-14 lg:after:w-14 xl:before:w-44 xl:after:w-44">
            //   {Array(1)
            //     .fill(null)
            //     .map((_item, idx) => (
            //H2 slide-animation
            <div className="w-full text-center">
              <h2 className="mb-5 text-h5 font-medium text-black-900 lg:mb-7 lg:text-h3 xl:text-h2">
                {heading}
              </h2>
            </div>
            //     ))}
            // </div>
          )}
          <div>
            {description && (
              <HtmlText className="mx-auto mb-5 text-center lg:mb-7 lg:max-w-[616px]">
                {description}
              </HtmlText>
            )}
            {logos && logos.length > 0 && (
              <div className="flex flex-wrap justify-center gap-7 md:gap-10 lg:gap-20 xl:gap-[100px]">
                {logos.map((logo, idx) => (
                  <div key={idx} className="h-9 max-w-20 md:max-w-[100px]">
                    <Image
                      className="size-full"
                      src={logo.src}
                      alt={logo.alt}
                      height={35}
                      width={126}
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReportingStandardSection;
